import AppPicture from '@/components/app-picture'
import AppIconPlay from '@/components/app-icon-play'
import AppIconExternal from '@/components/app-icon-external'
import AppIconFile from '@/components/app-icon-file'
import AppIconArrow from '@/components/app-icon-arrow'

export default
{
    name: 'app-page-home-push-item',

    components:
    {
        AppPicture,
        AppIconPlay,
        AppIconExternal,
        AppIconFile,
        AppIconArrow
    },

    props:
    {
        content: { type: Object, default: () => { return {} } },
        labelStoryOf: { type: String, default: '[name]' }
    },

    methods:
    {
        onVideoClick(video)
        {
            // Open URL
            if(video.url)
            {
                window.open(video.url, '_blank')
            }

            // Open player
            else
            {
                this.$eventHub.$emit('player.activate', video.ID)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-home-push-item/script.js